module.exports = __webpack_public_path__ + "img/logo-tony.5b7e81df.png";